// Tipos base para o builder de relatórios
export const WIDGET_TYPES = {
  HORIZONTAL_BAR: 'horizontalBar',
  VERTICAL_BAR: 'verticalBar',
  PIE_CHART: 'pieChart',
  DONUT_CHART: 'donutChart',
  MAP: 'map',
  CARD: 'card',
  GAUGE: 'gauge',
  INSIGHT: 'insight',
  TABLE: 'table',
  MATRIX: 'matrix',
  DRE: 'dreTable',
  DFC: 'dfcTable',
  ABC: 'abcCurve',
  FLUXO_CAIXA: 'fluxoCaixa',
  TITULOS_STATUS: 'titulosStatus',
  SALDOS: 'saldos'
};

export const CHART_TYPES = {
  BAR: 'bar',
  LINE: 'line',
  PIE: 'pie',
  DONUT: 'donut',
  AREA: 'area',
  SCATTER: 'scatter',
  RADAR: 'radar',
  HEATMAP: 'heatmap'
};

export const DATA_SOURCE_TYPES = {
  STATIC: 'static',
  API: 'api'
};

export const DATE_COMPARISON_TYPES = {
  NONE: 'none',
  PREVIOUS_PERIOD: 'previousPeriod',
  SAME_PERIOD_LAST_YEAR: 'samePeriodLastYear'
};

export const createDefaultLayout = (widgetId) => ({
  i: widgetId,
  x: 0,
  y: 0,
  w: 6,
  h: 4,
  minW: 2,
  minH: 2
});

export const createDefaultSection = () => ({
  sectionId: `section-${Date.now()}`,
  title: '',
  widgets: [],
  layout: []
});

export const createDefaultReport = () => ({
  reportId: `report-${Date.now()}`,
  reportName: 'Novo Relatório',
  widgets: [],
  layout: [],
  sections: [createDefaultSection()],
  globalFilters: {
    period: {
      from: new Date().toISOString().split('T')[0],
      to: new Date().toISOString().split('T')[0]
    },
    dateComparison: DATE_COMPARISON_TYPES.NONE
  }
});

// Converte um relatório antigo (sem sections) para o novo formato
export const normalizeReport = (report) => {
  if (!report) return createDefaultReport();

  // Já compatível
  if (Array.isArray(report.sections)) return report;

  return {
    ...report,
    sections: [{
      sectionId: 'legacy-section',
      title: '',
      widgets: report.widgets || [],
      layout : report.layout  || []
    }]
  };
};

// Manter compatibilidade com dashboard (depreciado)
export const createDefaultDashboard = createDefaultReport; 
